<template>
  <!-- ケアオーケストレーター申請一覧 -->
  <div id="COSettingRequestList">
    <div id="container-center">
      <coSettingNavi v-bind:pageid='"COSettingRequestList"' :careOrchestratorInstitutionId='this.careOrchestratorInstitutionId' :certificationFlag='this.certificationFlag' :searchConditions='this.searchConditions'></coSettingNavi>
      <requestListContent v-on:backMenu="back" :careOrchestratorInstitutionId='this.careOrchestratorInstitutionId' />
    </div>
    <div style="margin-top:10px;">
        <b-button class="backbutton is-primary" @click="back">メニューに戻る</b-button>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/guest/careorchestrator/SettingNaviBar";
import contents from "@/components/mock/guest/careorchestrator/setting/CORequestList";

export default {
  name: "COSettingRequestList",
  methods: {
    back: function() {
      this.$router.push({ path: "/guest/home" });
    },
  },
  data() {
    let careOrchestratorInstitutionId = this.$route.params["careOrchestratorInstitutionId"];
    let certificationFlag = this.$route.params["certificationFlag"];
    let searchConditions = this.$route.params["searchConditions"]
    return {
      careOrchestratorInstitutionId : careOrchestratorInstitutionId,
      certificationFlag: certificationFlag,
      searchConditions, searchConditions  
    };
  },
  filters: {},
  components: {
    coSettingNavi: naviBar,
    requestListContent: contents
  },
};
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/careorchestrator/COSettingRequestList.vue